/**
 * Utility functions for managing visitor IDs for anonymous chat users
 */

const VISITOR_ID_KEY = 'revoyager_visitor_id';

/**
 * Generate a simple UUID v4
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Get or create a visitor ID for anonymous users
 * Stored in localStorage to persist across sessions
 */
export function getVisitorId(): string {
  if (typeof window === 'undefined') {
    // Server-side rendering - return empty string
    return '';
  }

  try {
    let visitorId = localStorage.getItem(VISITOR_ID_KEY);

    if (!visitorId) {
      visitorId = generateUUID();
      localStorage.setItem(VISITOR_ID_KEY, visitorId);
    }

    return visitorId;
  } catch (error) {
    // localStorage might be unavailable (private browsing, etc.)
    console.warn('Could not access localStorage for visitor ID:', error);
    return generateUUID();
  }
}

/**
 * Clear the visitor ID from localStorage
 * Useful for testing or when user wants to start fresh
 */
export function clearVisitorId(): void {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(VISITOR_ID_KEY);
  } catch (error) {
    console.warn('Could not clear visitor ID from localStorage:', error);
  }
}
